import React, { useState, useEffect, useCallback } from 'react';
// import { loadStripe } from '@stripe/stripe-js';
// import config from '../../config';
import { getConnectedAccount } from '../../api/stripeConnect';
import { StripeAccountData } from '../../data/stripeTypes';
import { menuOptionTypes } from '../../pages/auth/Transactions';
import PaymentProcessing from './PaymentProcessing';


// const stripePromise = loadStripe(config.stripePublishableKey || '');

interface DashboardAccessProps {
  communityId?: string;
  userId?: string;
  setCurrentMenuOption: React.Dispatch<React.SetStateAction<menuOptionTypes>>;  
}

// interface StripeAccountData {
//   id: string;
//   object: string;
//   business_profile: {
//     annual_revenue: number | null;
//     estimated_worker_count: number | null;
//     mcc: string | null;
//     minority_owned_business_designation: string | null;
//     name: string | null;
//     product_description: string | null;
//     support_address: any | null;
//     support_email: string | null;
//     support_phone: string | null;
//     support_url: string | null;
//     url: string | null;
//   };
//   business_type: string | null;
//   capabilities: {
//     card_payments: 'active' | 'inactive' | 'pending';
//     transfers: 'active' | 'inactive' | 'pending';
//   };
//   charges_enabled: boolean;
//   controller: {
//     fees: {
//       payer: string;
//     };
//     is_controller: boolean;
//     losses: {
//       payments: string;
//     };
//     requirement_collection: string;
//     stripe_dashboard: {
//       type: string;
//     };
//     type: string;
//   };
//   country: string;
//   created: number;
//   default_currency: string;
//   details_submitted: boolean;
//   email: string;
//   external_accounts: any;
//   future_requirements: {
//     alternatives: any[];
//     current_deadline: number | null;
//     currently_due: string[];
//     disabled_reason: string | null;
//     errors: any[];
//     eventually_due: string[];
//     past_due: string[];
//     pending_verification: string[];
//   };
//   login_links: any;
//   metadata: {
//     community_id: string;
//     user_id: string;
//   };
//   payouts_enabled: boolean;
//   requirements: {
//     alternatives: any[];
//     current_deadline: number | null;
//     currently_due: string[];
//     disabled_reason: string | null;
//     errors: any[];
//     eventually_due: string[];
//     past_due: string[];
//     pending_verification: string[];
//   };
//   settings: {
//     bacs_debit_payments: any;
//     branding: any;
//     card_issuing: any;
//     card_payments: any;
//     dashboard: any;
//     invoices: any;
//     payments: any;
//     payouts: any;
//     sepa_debit_payments: any;
//   };
//   tos_acceptance: {
//     date: number | null;
//     ip: string | null;
//     user_agent: string | null;
//   };
//   type: string;
// }

const DashboardAccess: React.FC<DashboardAccessProps> = ({ communityId, userId, setCurrentMenuOption }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>('');
  // const [dashboardUrl, setDashboardUrl] = useState<string>('');
  // https://dashboard.stripe.com/test/payments/payouts
  const dashboardUrl = ""
  const [accountId, setAccountId] = useState<string>('');
  const [accountData, setAccountData] = useState<StripeAccountData | null>(null);
  const [showEmbeddedPayments, setShowEmbeddedPayments] = useState(false);

  // Helper to prettify requirement keys coming from Stripe
  const formatRequirement = (req: string) => {
    const ABBR = ['dob', 'ssn', 'ip', 'url', 'mcc'];
    return req
      .split('.')
      .map(segment =>
        segment
          .split('_')
          .map(word => {
            const lower = word.toLowerCase();
            if (ABBR.includes(lower)) return lower.toUpperCase();
            return lower.charAt(0).toUpperCase() + lower.slice(1);
          })
          .join(' ')
      )
      .join(' → ');
  };

  const handleGetConnectedAccount = useCallback(async () => {
    setIsLoading(true);
    setError('');
    
    try {
      const data = await getConnectedAccount(communityId!, userId!);
      if (data) {
        setAccountId(data.accountId);
        setAccountData(data.accountData);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to get account');
    } finally {
      setIsLoading(false);
    }
  }, [communityId, userId]);

  // const handleCreateDashboardLink = async () => {
  //   if (!accountId) {
  //     setError('Please get account first');
  //     return;
  //   }

  //   setIsLoading(true);
  //   setError('');

  //   try {
  //     const data = await createDashboardLink({
  //       accountId,
  //       returnUrl: `${window.location.origin}/payments`,
  //       refreshUrl: `${window.location.origin}/payments`,
  //     });

  //     setDashboardUrl(data.url);
  //   } catch (err) {
  //     setError(err instanceof Error ? err.message : 'Failed to create dashboard link');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const handleShowEmbeddedPayments = () => {
  //   setShowEmbeddedPayments(true);
  // };

  const openEmbeddedDashboard = () => {
    if (dashboardUrl) {
      // Open in a modal or new window
      window.open(dashboardUrl, '_blank', 'width=1200,height=800');
    }
  };

  useEffect(() => {
    if (communityId && userId) {
      handleGetConnectedAccount();
    }
  }, [communityId, userId, handleGetConnectedAccount]);

  // console.log("dashboard access")
  // console.log(accountId, accountData)
  // console.log(communityId, userId)

  return (
    <div className="space-y-6">
        {(!accountData || !!!(accountData.requirements.currently_due.length === 0 && accountData.charges_enabled)) && (<div className="flex flex-row justify-between bg-blue-50 p-4 rounded-lg w-full">
          <div className="flex flex-col">
            <h2 className="text-lg font-semibold mb-2">{accountData ? "Finish Setup" : "Begin Setup"}</h2>
            <p className="text-sm text-gray-600">
              {accountData 
                ? 'Complete onboarding requirements to manage your existing payment account and accept payments.'
                : 'Create a payment account and complete onboarding requirements to accept payments.'
              }
            </p>
          </div>

          {(
            <button
              onClick={() => setCurrentMenuOption("payment_account")}
              disabled={isLoading}
              className="bg-primary-400 text-white py-2 px-4 rounded hover:bg-primary-300 disabled:opacity-50 "
            >
              Complete Setup
            </button>
          )}
   

        
        
        
        {/* Debug Information */}
        {/* <div className="mt-4 p-3 bg-gray-100 rounded text-xs">
          <p><strong>Debug Info:</strong></p>
          <p>Community ID: {communityId || 'Not set'}</p>
          <p>User ID: {userId || 'Not set'}</p>
          <p>Existing Account: {existingAccount ? 'Yes' : 'No'}</p>
          <p>Account ID: {accountId || 'Not set'}</p>
          <p>Loading: {isLoading ? 'Yes' : 'No'}</p>
          <button
            onClick={handleRefreshAccount}
            disabled={isLoading}
            className="mt-2 px-2 py-1 bg-gray-500 text-white text-xs rounded hover:bg-gray-600 disabled:opacity-50"
          >
            {isLoading ? 'Loading...' : 'Refresh Account'}
          </button>
        </div> */}
      </div>)}

      <div className="space-y-4">
        {
          (!accountId && !accountData) && (
            <>
            <div className="bg-green-50 p-4 rounded-lg">
              <h2 className="text-lg font-semibold mb-2">Dashboard Access</h2>
              <p className="text-sm text-gray-600">
                Provided with access to manage your payment account.
              </p>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                No payment account yet
              </div>
            )}
            {/* <button
              onClick={handleGetConnectedAccount}
              disabled={isLoading}
              className="w-full bg-primary-300 text-white py-2 px-4 rounded hover:bg-primary-400 disabled:opacity-50"
            >
              {isLoading ? 'Loading Account...' : 'Get Connected Account'}
            </button> */}
            </>
          )
        }

        {/* {accountId && (
          <div className="bg-green-50 p-4 rounded-lg">
            <p className="text-sm text-green-700">
              Account found! Account ID: {accountId}
            </p>
          </div>
        )} */}

        {/* Account Information Display */}
        {accountData && (
          <div className="bg-white border rounded-lg p-6 space-y-6">
            <h3 className="text-lg font-semibold text-gray-900">Payment Account</h3>

            {/* Account Status */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-gray-700">Account Status:</span>
                  <span className={`px-2 py-1 rounded text-xs ${
                    accountData.charges_enabled ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {accountData.charges_enabled ? 'Active' : 'Pending'}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-gray-700">Details Submitted:</span>
                  <span className={`px-2 py-1 rounded text-xs ${
                    accountData.details_submitted ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {accountData.details_submitted ? 'Yes' : 'No'}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-gray-700">Account Type:</span>
                  <span className="text-sm text-gray-900">{accountData.controller.stripe_dashboard.type}</span>
                </div>
              </div>
              
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-gray-700">Country:</span>
                  <span className="text-sm text-gray-900">{accountData.country}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-gray-700">Currency:</span>
                  <span className="text-sm text-gray-900">{accountData.default_currency.toUpperCase()}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-gray-700">Created:</span>
                  <span className="text-sm text-gray-900">{new Date(accountData.created * 1000).toLocaleDateString()}</span>
                </div>
              </div>
            </div>

            {/* Requirements Status */}
            {accountData.requirements.currently_due.length > 0 && (
              <div>
                <h4 className="text-md font-medium text-gray-900 mb-3 flex items-center gap-2">
                  <span className="inline-flex items-center justify-center w-4 h-4 bg-yellow-400 text-white text-[10px] font-bold rounded-full">!</span>
                  Pending Requirements
                </h4>
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 space-y-4">
                  <p className="text-sm text-yellow-800">
                    The following requirements need to be completed:
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {accountData.requirements.currently_due.map((requirement, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center bg-yellow-100 text-yellow-800 text-xs font-medium px-3 py-1 rounded-full"
                      >
                        {formatRequirement(requirement)}
                      </span>
                    ))}
                  </div>
                  {accountData.requirements.current_deadline && (
                    <p className="text-sm text-yellow-800">
                      <strong>Deadline:</strong> {new Date(accountData.requirements.current_deadline * 1000).toLocaleDateString()}
                    </p>
                  )}
                </div>
              </div>
            )}

          </div>
        )}

        {dashboardUrl && (
          <div className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg">
              <p className="text-sm text-blue-700">
                Dashboard link created successfully!
              </p>
            </div>
            
            <button
              onClick={openEmbeddedDashboard}
              className="w-full bg-purple-500 text-white py-2 px-4 rounded hover:bg-purple-600"
            >
              Open Payment Dashboard
            </button>

            <div className="text-sm text-gray-600">
              <p>Dashboard URL: {dashboardUrl}</p>
            </div>
          </div>
        )}
      </div>

      {
        (accountId && accountData && (accountData.requirements.currently_due.length === 0 && accountData.charges_enabled)) && (
          <div className="space-y-4 flex flex-row justify-between">
            {/* <button 
              className="bg-primary-400 text-white py-2 px-4 rounded hover:bg-primary-300 disabled:opacity-50" 
              onClick={handleCreateDashboardLink} 
              disabled={isLoading}
            >
              {isLoading ? 'Loading Payment Dashboard...' : 'View Payment Dashboard'}
            </button> */}
            
            <button 
              className="bg-primary-400  text-white py-2 px-4 rounded hover:bg-purple-600 disabled:opacity-50" 
              onClick={() => setCurrentMenuOption("payments")} 
              disabled={isLoading}
            >
              View Payment Dashboard
            </button>
          </div>
        )
      }

      {/* Dashboard Features Overview */}
      <div className="mt-8 bg-gray-50 p-4 rounded-lg">
        <h3 className="text-lg font-semibold mb-3">Dashboard Features</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div className="space-y-2">
            <div className="flex items-center">
              <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
              <span>View payouts and transactions</span>
            </div>
            <div className="flex items-center">
              <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
              <span>Manage refunds and disputes</span>
            </div>
            <div className="flex items-center">
              <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
              <span>Access reporting and analytics</span>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center">
              <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
              <span>Process charges independently</span>
            </div>
            <div className="flex items-center">
              <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
              <span>Manage account settings</span>
            </div>
            <div className="flex items-center">
              <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
              <span>Access Stripe support</span>
            </div>
          </div>
        </div>
      </div>

      {/* Embedded Payments Modal */}
      {showEmbeddedPayments && communityId && userId && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-6xl h-[90vh] overflow-y-auto">
            <PaymentProcessing 
              communityId={communityId}
              userId={userId}
              onClose={() => setShowEmbeddedPayments(false)}
              enableRefunds={true}
              enableDisputes={true}
              enableCapturePayments={true}
              enableDestinationChargeManagement={false}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardAccess; 